import { useRequest } from 'ahooks';
import type { Options, Result } from 'ahooks/lib/useRequest/src/types';
import type { BaseModel, IExtra } from './createRequest';
import { RemoveAnd } from '@/kus/flat';
export function createUseRequest<IModels extends BaseModel, U extends keyof IModels = keyof IModels>(
    fetchFn: (...args: any[]) => Promise<IModels[U]['responses']>,
) {
    return function useHttp<T extends keyof IModels>(
        url: T,
        payload?: RemoveAnd<{ body?: IModels[T]['requestBody'] } & IModels[T]['parameters']> | null,
        options?: {
            extra?: IExtra;
        } & Options<IModels[T]['responses'], [RemoveAnd<{ body?: IModels[T]['requestBody'] } & IModels[T]['parameters']>]>,
    ): Result<IModels[T]['responses'], [RemoveAnd<{ body?: IModels[T]['requestBody'] } & IModels[T]['parameters']>]> {
        const { extra, ...requestOptions } = options || {};

        return useRequest<IModels[T]['responses'], [RemoveAnd<{ body?: IModels[T]['requestBody'] } & IModels[T]['parameters']>]>(async (params) => {
            const res = await fetchFn(url, params || payload, extra);
            return res;
        }, requestOptions);
    };
}
